export default "__VITE_ASSET__vZ8GUnXb__"